/**
 * Acceso desde TypeScript a los tokens de Figma (`src/styles/_tokens.scss`).
 *
 * Casi todo el diseño se resuelve con `var(--token)` en CSS. Esto es para las
 * APIs que reciben un color como string y no entienden variables CSS —
 * básicamente Google Maps (estilos de features, pines): así el color sigue
 * saliendo de un solo lugar.
 */

import { NombreToken } from './nombres-token';

const cache = new Map<string, string>();

/**
 * Lee un token de `:root` y devuelve su valor.
 *
 * `NombreToken` sale del generador: si la paleta se renombra, las llamadas
 * dejan de compilar en vez de caer al respaldo en silencio.
 *
 * @param nombre Token sin `--`, p. ej. `c-phindi-rose_500`.
 * @param respaldo Valor a usar si el token no resolvió (hoja aún no aplicada,
 *   o entorno sin DOM).
 */
export function token(nombre: NombreToken, respaldo: string): string {
  const cacheado = cache.get(nombre);
  if (cacheado !== undefined) return cacheado;

  if (typeof document === 'undefined') return respaldo;

  const valor = getComputedStyle(document.documentElement)
    .getPropertyValue(`--${nombre}`)
    .trim();

  // Sin hoja de estilos aplicada todavía devuelve '': no se cachea el vacío
  // para que la próxima llamada vuelva a intentar.
  if (!valor) return respaldo;

  cache.set(nombre, valor);
  return valor;
}
